import {
  PermissionCategory,
  type Permission,
  PermissionType,
} from '@repo/api-gw-sdk';

export type PermissionDescriptor = Permission & {
  group?: string;
};

const permissions: Record<PermissionType, { group?: string }> = {
  [PermissionType.GlobalSettingsView]: {},
  [PermissionType.VaultAccountsManage]: {},
  [PermissionType.CostExplorerView]: {},
  [PermissionType.AuditLogsView]: {
    group: 'Access management',
  },
  [PermissionType.UserAccessManage]: {
    group: 'Access management',
  },
  [PermissionType.SamlGroupAccessManage]: {
    group: 'Access management',
  },
  [PermissionType.ApiCredentialsManage]: {
    group: 'Access management',
  },
  [PermissionType.ApiCredentialsRotateSecret]: {
    group: 'Access management',
  },
  [PermissionType.CustomRolesManage]: {
    group: 'Access management',
  },
  [PermissionType.OauthAppsManage]: {
    group: 'Integrations',
  },
  [PermissionType.NotificationPoliciesManage]: {
    group: 'Integrations',
  },
  [PermissionType.PermissionIdUnspecified]: {},
  [PermissionType.DashboardView]: {},
  [PermissionType.InventoryView]: {},
  [PermissionType.JobsView]: {},
  [PermissionType.BackupSettingsView]: {},
  [PermissionType.StorageGatewayView]: {},
  [PermissionType.DatabaseExplorerSearch]: {
    group: 'Search and explore',
  },
  [PermissionType.FileExplorerSearch]: {
    group: 'Search and explore',
  },
  [PermissionType.SnapshotsTakeOrConvert]: {},
  [PermissionType.ResourcesRestore]: {},
  [PermissionType.ConfigurationValidate]: {},
  [PermissionType.FilesRestore]: {
    group: 'Restore granular data',
  },
  [PermissionType.DatabasesQuery]: {
    group: 'Restore granular data',
  },
  [PermissionType.DataClassesOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.EnvironmentsOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.DetectedAppsOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.ControlViolationsMute]: {},
  [PermissionType.BackupExclusionManage]: {},
  [PermissionType.VaultsManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.SourceAccountsManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.RestoreAccountsManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.BackupPoliciesManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.DiscoveryConfigurationManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.BackupConfigurationManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.ZeroEtlPoliciesManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.ControlsManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.RansomwareDetectionManage]: {
    group: 'Manage backup settings',
  },
  [PermissionType.StorageGatewayManage]: {
    group: 'Storage gateway',
  },
  [PermissionType.MpaPoliciesManage]: {
    group: 'Access management',
  },
  [PermissionType.MpaPoliciesView]: {
    group: 'Access management',
  },
  [PermissionType.MpaRequestsManage]: {
    group: 'Access management',
  },
  [PermissionType.RestoreTemplatesManage]: {},
  [PermissionType.DatalakeView]: {
    group: 'Managed datalake',
  },
  [PermissionType.DatalakeOperate]: {
    group: 'Managed datalake',
  },
};

export const Permissions = Object.fromEntries(
  Object.entries(permissions).filter(
    ([key]) => key !== PermissionType.PermissionIdUnspecified
  )
);

const permissionCategories: Record<PermissionCategory, { title: string }> = {
  [PermissionCategory.PERMISSION_CATEGORY_ADMINISTRATION]: {
    title: 'Administration',
  },
  [PermissionCategory.PERMISSION_CATEGORY_GLOBAL_MANAGEMENT]: {
    title: 'Global management',
  },
  [PermissionCategory.PERMISSION_CATEGORY_OPERATION]: {
    title: 'Operation',
  },
  [PermissionCategory.PERMISSION_CATEGORY_VIEWING]: {
    title: 'Viewing',
  },
};

export const PermissionCategories = Object.fromEntries(
  Object.entries(permissionCategories)
);
